import {atom} from "recoil";
import keys from "configs/atoms";
import {REFRESHTOKEN_KEY, ACCESSTOKEN_KEY} from "configs/api";

const hasToken = (key) => {
    const v = localStorage.getItem(key);
    return !!v && v !== 'undefined';
};

const initValue = {
    isAuthenticated: hasToken(ACCESSTOKEN_KEY) && hasToken(REFRESHTOKEN_KEY),
    isLoggedIn: false,
    accountLoaded: false,
    redirToLogout: false,
    isRefreshTokenExpired: false,
}

const auth = atom(({
    key: keys.Account.Auth,
    default: structuredClone(initValue) 
}));

export default auth;